<template>
  <div class="layout">
    <Header />
    <router-view />
    <!-- <Footer /> -->
  </div>
</template>

<script>
  import Header from './components/header.vue'
  // import Footer from "./components/footer.vue";

  export default {
    name: 'Layout',
    components: {
      Header,
    },
  }
</script>

<style lang="scss" scoped></style>
